<div [ngClass]="{ 'invalid-state': showInvalidIndicator }">
  <ng-content></ng-content>
</div>
<div class="errors" *ngIf="showInvalidIndicator">
  {{ errorMessage }}
</div>
